module.exports = __webpack_public_path__ + "img/dashboard-right-arrow.13981818.svg";